<template>
  <div>
    <el-dialog v-dialogDrag :title="title" :visible.sync="isDialog" width="500px" @close="clearFun('role')" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form size="small" :model="role" ref="role" :rules="rules" label-width="100px">
        <el-form-item label="编码：" prop="code">
          <el-input v-model="role.code"/>
        </el-form-item>
        <el-form-item label="名称：" prop="name">
          <el-input v-model="role.name"/>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" v-model="role.remark" maxlength="200" placeholder="请输入内容" rows="3" show-word-limit/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="isDialog = false" size="small">取消</el-button>
        <el-button type="primary" size="small" @click="submitFun('role')">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddOrUpdate',
  props: {
    //列表刷新
    refresh: {
      type: Function
    }
  },
  data() {
    //用户名重复校验
    let checkCode = (rule, value, callback) => {
      this.$axios.get('/sysRole/checkCode', {
        params: {
          code: value,
          id: this.role.id
        }
      }).then(response => {
        if(response){
          callback(new Error('编码已经存在'))
        }
        else {
          callback()
        }
      })
    }
    return {
      //标题
      title: '新增',
      //是否打开弹窗
      isDialog: false,
      //数据
      role: {},
      //验证规则
      rules: {
        code: [{
          required: true,
          message: '请输入编码',
          trigger: 'blur'
        }, {
          validator: checkCode,
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    //提交
    submitFun: function(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //数据提交保存
          this.$axios({
            method: 'post',
            url: '/sysRole/saveOrUpdate',
            data: this.role
          }).then(response => {
            this.refresh()
            this.isDialog = false
            this.$message.success('保存成功~')
          })
        } else {
          return false;
        }
      });
    },
    //清除表单数据
    clearFun: function(formName){
      this.$refs[formName].resetFields()
      this.role = {}
    }
  }
}
</script>

<style scoped>
  .width-full {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/system/role/AddOrUpdate.vue